import { CookieService } from 'ngx-cookie-service';
import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import getToken from '@app/utils/get-token';

@Injectable()
export class ServerSelectInterceptor implements HttpInterceptor {
  constructor(private http: HttpClient, private translate: TranslateService, private cookieService: CookieService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const reqCopy = this.setHeaders(req);
    return next.handle(reqCopy).catch((err: any, caught) => {
      /*if (err.status >= 500) {
          // this.getNextServer();
          return this.sendReq(this.setHeaders(req));
        }§
        else*/
      return Observable.throw(err);
    });
  }

  sendReq(req: HttpRequest<any>) {
    return this.http.request(req);
  }

  setHeaders(req: HttpRequest<any>): HttpRequest<any> {
    let index = req.url.indexOf('#');
    if (~index) {
      let server = req.url.substr(0, index);
      if (server) {
        req = req.clone({
          url: `${environment.config[server]}/${req.url.replace(server + '#', '')}`,
          headers: req.headers
            .set('Accept', 'application/json, text/plain, */*')
            .set('Authorization', getToken(this.cookieService, true))
        });
      }
    }
    if (
      !~req.url.indexOf('imgs/') &&
      !~req.url.indexOf('redmine/') &&
      !~req.url.indexOf('http') &&
      !~req.url.indexOf('driver-registration') &&
      !~req.url.indexOf('media')
    ) {
      // Clone the request to add the new header.
      if (req.url.indexOf('admin-call-way-report') + 1) {
        let req1 = req.clone({
          url: `${environment.config.telephonyServer}/${req.url}`,
          headers: req.headers
            .set('Accept', 'application/json, text/plain, */*')
            .set('Authorization', getToken(this.cookieService, true))
        });

        return req1;
      }
      return req.clone({
        url: `${environment.config.http}${environment.config.domain}/${environment.config.client}/${req.url}`,
        headers: req.headers.set('Authorization', getToken(this.cookieService, true))
        // .set('X-Client-Id', environment.config.client)
      });

      // Pass on the cloned request instead of the original request.
    } else if (!!~req.url.indexOf('v2/operator')) {
      // second version of estimator
      return req.clone({
        url: req.url,
        headers: req.headers.set('Authorization', getToken(this.cookieService, true))
      });
    } else if (!!~req.url.indexOf('driver-registration') || !!~req.url.indexOf('media')) {
      // requests to registration server
      return req.clone({
        url: `${environment.config.registrationServer}/${req.url}`,
        headers: req.headers.set('Authorization', getToken(this.cookieService, true))
      });
    } else if (!!~req.url.indexOf('media')) {
      return req.clone({
        url: `${environment.config.registrationServer}/${req.url}`,
        headers: req.headers
      });
    } else {
      return req.clone({
        url: req.url,
        headers: req.headers.set('Accept-Language', this.translate.currentLang || '')
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/Intercepters/server-select.interceptor.ts